import Logo from "../../../assets/png/tuataraLogo.png";
import OIPImg from "../../../assets/svg/OIP.svg";
import { Link } from "react-router-dom";
const HomeFooter = () => {
  return (
    <div className="bg-[#292929]">
      <div className="custom-container">
        <div className="lg:pt-[90px] md:pt-[70px] sm:pt-[60px] pt-[50px]  lg:pb-[56px] md:pb-[46px] pb-[40px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 lg:gap-x-[110px] md:gap-x-[80px] sm:gap-x-[40px] gap-x-[0px] lg:gap-y-[45px] md:gap-y-[35px] sm:gap-y-[25px] gap-y-[20px] border-b-[#7ABF5B] border-b-[1px] lg:pb-[53px] md:pb-[40px] sm:pb-[30px] pb-[20px]">
            <div className="flex items-end">
              <img src={Logo} alt="" className="max-h-[124px]" />
            </div>
            {/* <div>
              <button
                className="
                rounded-lg 
                bg-[#7ABF5B] 
                font-[Roboto] 
                2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px]
                text-[#5B792E]  

                lg:py-[22px] 
                md:py-[18px] 
                sm:py-[15px] 
                py-[10px] 
                font-bold 
                my-[10px]
                text-white
                w-full"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                FIND A DEALER
              </button>
            </div> */}
            {/* <div>
              <button
                className="
                rounded-lg 
                bg-[#5B792E] 
                font-[Roboto] 
                2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px]
                text-[#5B792E]  

                lg:py-[22px] 
                md:py-[18px] 
                sm:py-[15px] 
                py-[10px] 
                font-bold 
                my-[10px]
                text-white
                w-full"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                BECOME A DEALER
              </button>
            </div> */}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 lg:gap-x-[110px] md:gap-x-[80px] sm:gap-x-[40px] gap-x-[0px] lg:gap-y-[45px] md:gap-y-[35px] sm:gap-y-[25px] gap-y-[20px] border-b-[#7ABF5B] border-b-[1px] lg:mt-[60px] md:mt-[40px] sm:mt-[30px] mt-[20px] lg:pb-[63px] md:pb-[40px] sm:pb-[30px] pb-[20px]">
            <div>
              <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#000] font-extrabold text-[#FFFFFF] border-b-[#7ABF5B] border-b-[1px] pb-[18px]">
                ABOUT TUATARA
              </div>
              <div className="grid lg:grid-cols-2 pt-[18px]">
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link to="/us/about" onClick={() => window.scrollTo(0, 0)}>
                    About
                  </Link>
                </div>
                {/* <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Community & Events
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Careers
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Investor Relations
                </div> */}
                {/* <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Careers
                </div> */}
                {/* <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  News & Media
                </div> */}
              </div>
            </div>
            <div>
              <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#000] font-extrabold text-[#FFFFFF] border-b-[#7ABF5B] border-b-[1px] pb-[18px]">
                POWER SYSTEMS
              </div>
              <div className="grid lg:grid-cols-2 pt-[18px]">
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link to="/us/1000EFI" onClick={() => window.scrollTo(0, 0)}>
                    Gasoline
                  </Link>
                </div>
                {/* <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link to="/us/warrnty" onClick={() => window.scrollTo(0, 0)}>
                    Warranty
                  </Link>
                </div> */}
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link
                    to="/us/tu-1500e-2"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Electric
                  </Link>
                </div>
                {/* <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Operator Manuals
                </div> */}
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link
                    to="/us/tu-SC2500E-1"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Dual Motor
                  </Link>
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link
                    to="/us/attachments"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    Attachments
                  </Link>
                </div>
              </div>
            </div>
            <div>
              <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#000] font-extrabold text-[#FFFFFF] border-b-[#7ABF5B] border-b-[1px] pb-[18px]">
                STAY CONNECTED
              </div>
              <div className="grid grid-cols-1 pt-[18px]">
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal text-white pb-[18px]">
                  Receive the latest news, special offers and exclusives.
                </div>
                <div className="flex flex-col md:flex-row items-center md:items-stretch gap-x-0 gap-y-4">
                  <input
                    type="email"
                    className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal text-[#292929] bg-white focus:outline-none px-4 py-2 flex-1 h-[48px] md:h-[58px]"
                    placeholder="EMAIL"
                  />
                  <button className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal text-white bg-[#7ABF5B] px-6 py-2 hover:bg-[#66a54b] transition">
                    SUBSCRIBE
                  </button>
                </div>
                <div className="italic font-[Roboto] text-[14px] md:text-[16px] lg:text-[20px] text-center md:text-left text-white py-4">
                  *Manage Subscription Preferences
                </div>
              </div>
            </div>
            {/* <div>
              <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#000] font-extrabold text-[#FFFFFF] border-b-[#7ABF5B] border-b-[1px] pb-[18px]">
                FLEET VEHICLES
              </div>
              <div className="grid lg:grid-cols-5 pt-[18px]">
                <div className="lg:col-span-2 md:col-span-1 col-span-1 font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Agriculture
                </div>
                <div className="lg:col-span-3 md:col-span-1 col-span-1 font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Mines, Quarries, & Refineries
                </div>
                <div className="lg:col-span-2 md:col-span-1 col-span-1 font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Construction
                </div>
                <div className="lg:col-span-3 md:col-span-1 col-span-1 font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Zoos, Museums, & Recreation
                </div>
                <div className="lg:col-span-2 md:col-span-1 col-span-1 font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Forestry & Wildlife
                </div>
                <div className="lg:col-span-3 md:col-span-1 col-span-1 font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Contact a Commercial Rep
                </div>
              </div>
            </div> */}
            <div>
              <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#000] font-extrabold text-[#FFFFFF] border-b-[#7ABF5B] border-b-[1px] pb-[18px]">
                MODELS
              </div>
              <div className="grid lg:grid-cols-2 pt-[18px]">
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link to="/us/1000EFI" onClick={() => window.scrollTo(0, 0)}>
                    1000EFI-2
                  </Link>
                </div>
                {/* <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link
                    to="/us/tu-1500e-4"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    11500E-4
                  </Link>
                </div> */}
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link
                    to="/us/tu-1500e-2"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    1500E-2
                  </Link>
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link
                    to="/us/tu-SC2500E-1"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    SC2500-01
                  </Link>
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link
                    to="/us/tu-1500e-3"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    1500E-3
                  </Link>
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  <Link
                    to="/us/tu-DC2500E-1"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    DC2500-01
                  </Link>
                </div>
              </div>
            </div>
            {/* <div>
              <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#000] font-extrabold text-[#FFFFFF] border-b-[#7ABF5B] border-b-[1px] pb-[18px]">
                GOVERNMENT & DEFENSE
              </div>
              <div className="grid lg:grid-cols-2 pt-[18px]">
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Military
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  State
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Agency
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Municipal
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Federal
                </div>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal cursor-pointer text-white pb-[18px]">
                  Emergency Response
                </div>
              </div>
            </div> */}
          </div>
          {/* <div className="border-b-[#7ABF5B] border-b-[1px] py-[32px] flex items-center flex-wrap justify-center	">
            <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-bold cursor-pointer text-white lg:pb-[0px] pb-[18px] mx-[38px] text-center">
              PRIVACY POLICY
            </div>
            <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-bold cursor-pointer text-white lg:pb-[0px] pb-[18px] mx-[38px] text-center">
              TERMS & CONDITIONS
            </div>
            <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-bold cursor-pointer text-white lg:pb-[0px] pb-[18px] mx-[38px] text-center">
              U.S PATENT
            </div>
            <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-bold cursor-pointer text-white lg:pb-[0px] pb-[18px] mx-[38px] text-center">
              TRADEMARK
            </div>
          </div> */}
          <div className="mt-[39px]">
            <div className="flex flex-wrap items-center">
              <div>
                <a href="https://www.alphaomegaequipment.com" target="_blank">
                  <img src={OIPImg} alt="" className="w-[154px] h-auto" />
                </a>
              </div>
              <div>
                <a href="https://www.alphaomegaequipment.com" target="_blank">
                  <div className="font-[Rockwell] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-extrabold text-[#fff]">
                    DISTRIBUTED BY A&O DISTRIBUTION
                  </div>
                </a>
                <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal text-[#fff]">
                  {/* 15221 Market St.
                  <br /> Channelview, TX 77530 */}
                  10182 Hwy 35
                  <br /> Van Vleck, TX 77482
                  <br /> USA
                  <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-2 md:gap-x-2 mt-1">
                    Tel:{" "}
                    <a
                      href="tel:+4053973944"
                      target="_blank"
                      className="text-[#E09900]"
                    >
                      405-397-3944
                    </a>
                    Web:{" "}
                    <a
                      href="https://www.tuataraatv.com/us"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline text-[#E09900] block"
                    >
                      www.tuataraatv.com/us
                    </a>
                    Email:{" "}
                    <a
                      href="mailto:info@tuataraatv.com"
                      className="hover:underline text-[#E09900] block"
                    >
                      info@tuataraatv.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-[10px] font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal text-[#fff]">
              {`©${new Date().getFullYear()} Tuatara USA. All rights reserved. ®, TM and the Tuatara logo are trademarks of Tuatara USA, Tuatara Machinery Limited or its affiliates. In the U.S.A., the products are distributed by A&O Distribution LLC. A&O Distribution is a branch of Alpha & Omega Equipment Sales & Rentals.  All other trademarks are the property of their respective owners. For other jurisdictions, see your local dealer. Tuatara reserves the right, at any time, to discontinue or change specifications, prices, designs, features, models or equipment without incurring obligation. Some models depicted may include optional equipment. Read the side-by-side vehicle (SxS) operator’s guide before driving. For your safety, wear a helmet, eye protection and other protective gear. Fasten seat belt at all times. Always remember that driving a SxS, alcohol and drugs don’t mix. SxSs are for off-road use only. Never drive on paved surfaces or public roads unless licenced to do so. Operators must be at least 16 years old. Passenger must be at least 12 years old and able to hold hand grips and plant feet while seated against the backrest. Never engage in stunt driving and avoid excessive speed. Drive responsibly. `}
            </div>{" "}
            <div className="pt-[21px] flex items-center md:flex-row flex-col flex-wrap gap-12 justify-start">
              <div className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-extrabold cursor-pointer text-white lg:pb-[0px] pb-[18px] text-center lg:mr-[0px] md:mr-[38px] mr-[0px] text-left">
                {/* SITEMAP */}
                <a
                  href="/sitemap.xml" // file is inside public folder
                  target="_blank" // opens in new tab
                  rel="noopener noreferrer"
                  className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-extrabold cursor-pointer text-white lg:pb-[0px] pb-[18px] text-center lg:mr-[0px] md:mr-[38px] mr-[0px] text-left"
                >
                  SITEMAP
                </a>
              </div>
              <a
                href="http://www.strategicevolutions.ca"
                target="_blank"
                className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-bold cursor-pointer text-white lg:pb-[0px] pb-[18px] text-center lg:mr-[0px] md:mr-[38px] mr-[0px] text-left"
              >
                SITE BUILT BY STRATEGIC EVOLUTIONS
              </a>
              {/* <a
                href="http://www.vizybilitydms.com"
                target="_blank"
                className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-bold cursor-pointer text-white lg:pb-[0px] pb-[18px] text-center lg:mr-[0px] md:mr-[38px] mr-[0px] text-left"
              >
                U.S PATENT
              </a>
              <a
                href="https://www.impactmarketing.co"
                target="_blank"
                className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-bold cursor-pointer text-white lg:pb-[0px] pb-[18px] text-center  lg:mr-[0px] md:mr-[38px] mr-[0px] text-left"
              >
                TRADEMARK
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomeFooter;
